<ng-container *transloco="let t">
    <vds-dialog-header [closeLabel]="t('appTextClose')"></vds-dialog-header>
    <vds-dialog-content class="pb-24">
        @if (termsResource.isLoading()) {
            <div class="flex items-center justify-center p-16">
                <vds-progress-spinner />
            </div>
        } @else if (termsResource.hasValue()) {
            <vui-rich-text-container [innerHTML]="termsResource.value().content"></vui-rich-text-container>
        }
    </vds-dialog-content>
</ng-container>
